import { SearchLg } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonCmp from 'src/components/ButtonCmp';
import InputText from 'src/components/InputText/InputText';

interface IFilterLayoutProps {
    children?: React.ReactNode;
    isSaveBtn?: boolean;
    onSave?: () => void;
    // Optional: renders the Apply button between Cancel and Save View (WAL's filter bar).
    // Screens that apply filters live as they change simply omit it.
    onApply?: () => void;
    onCancel: () => void;
    search: string;
    handleSearchChange: (value: string) => void;
    isSaveEnable?: boolean;
    isLoading?: boolean;
}

const FilterLayout = ({ children, isSaveBtn = true, onSave, onApply, onCancel, search, handleSearchChange, isSaveEnable, isLoading }: IFilterLayoutProps) => {
    const searchValue = search ?? '';
    const { t } = useTranslation();

    return (
        <div className="">
            <div className="table-header-filter-space border-b border-utilityGray200 flex gap-2">
                <InputText
                    inputName="searchQuote"
                    size="sm"
                    placeholder={t('Common.Search')}
                    className="bg-white focus:bg-white pl-8 pr-7 placeholder:text-gray500 shadow-sm font-normal search-input"
                    icon={<SearchLg className="absolute top-1/2 -translate-y-1/2 left-2 text-grayText h-4 w-4" />}
                    inputType="text"
                    value={searchValue}
                    onChangeFunc={handleSearchChange}
                    parentClassName="table-searchInput !flex-1"
                    isClearable={true}
                    autoFocus={true}
                />

                <ButtonCmp type="button" onClick={onCancel} className="btn_secondary_black">
                    Cancel
                </ButtonCmp>
                {onApply && (
                    <ButtonCmp type="button" onClick={onApply} disabled={isLoading} className="btn_primary">
                        {t('Common.Apply')}
                    </ButtonCmp>
                )}
                {isSaveBtn && (
                    <ButtonCmp type="button" onClick={onSave} disabled={!isSaveEnable || isLoading} loading={isLoading} className="btn-outline-primary">
                        Save View
                    </ButtonCmp>
                )}
            </div>

            <div className="border-b border-utilityGray200 table-header-filter-space flex overflow-x-auto scrollbar-hide gap-2 empty:hidden">{children}</div>
        </div>
    );
};

export default FilterLayout;
